import React from "react";

import Framework from "@beardeddevops/react.framework";
import { Types } from "components";
import API from "@beardeddevops/react.api";
import {Button, Alert} from 'reactstrap';
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import {FormControl, FormControlLabel, Paper} from "@material-ui/core";

export default class MarketingBanner extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Location_Banners._name);
		this.state = {
			marketing_title: '',
			marketing_subtitle: '',
			marketing_description: '',
			//Call to Action (cta)
			marketing_cta_text: '',
			marketing_cta_url: '',
			marketing_background_color: '#FFFFFF',
			marketing_foreground_color: '#000000',
			selectedOption: '',
			persist: false
		};
	}

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value });
	}

	getActiveBanner = async () => {
		let bannerModel = new API.BuildClass(Types.Location_Banners._name, 'GET_ACTIVE_BANNER');
		bannerModel.object.account = 1;
		let banner_result = await bannerModel.submit(null, 'GET_ACTIVE_BANNER');
		if(banner_result) {
			this.setState({
				persist_banner: banner_result.persist_banner,
				dismiss_banner: banner_result.active_banner
			})
			this.setState({banner_result});
		}
	}


	componentDidMount() {
		this.getActiveBanner().then();
	}


	handleCheckChangeFor = async () => {
		await this.setState({persist: !this.state.persist})
	}


	// I don't know how to complete this method
	handleSubmit = async (event) => {
		event.preventDefault();
		if (typeof this.state.marketing_start_date === 'undefined') {
			this.state.marketing_start_date = new Date().toLocaleString();
		}
		switch(this.state.customer_group) {
			case 'Manager':
				this.state.user_access = 1;
				break;
			case 'Supervisor':
				this.state.user_access = 2;
				break;
			case 'Employee':
				this.state.user_access = 3;
				break;
			case 'Owner':
				this.state.user_access = 4;
				break;
			case 'All':
				this.state.user_access = 5;
				break;
			default:
				this.state.user_access = 4;
				break;
		}

		let bannerModel = new API.BuildClass(Types.Location_Banners._name, 'PUT_MARKETING_BANNER')
		await bannerModel.submit(this, 'PUT_MARKETING_BANNER');
	}

	handleSelectChange = (e) => {
		this.setState({customer_group: e.target.value });
	};

	handleRemoveBanner = async () => {
		let bannerModel = new API.BuildClass(Types.Location_Banners._name, 'POST_REMOVE_BANNER_FROM_VIEW');
		bannerModel.object.set_number = this.state.banner_result.data.SetNumber;
		bannerModel.object.pkey = this.state.banner_result.data.SetNumber;
		bannerModel.object.location_banner = this.state.banner_result.data.SetNumber;
		await bannerModel.submit(null, 'POST_REMOVE_BANNER_FROM_VIEW');
	}

	handleDateChange = (name, value) => {
		// console.log('moment date', momentDate, value)
		this.setState({[name]: value})
	};

	render() {
		const { customer_group } = this.state;
		// console.log('this in render', this);
		return (
			<div>
			<form onSubmit={this.handleSubmit}>
				<div>
					<label>
						Title:
						<input
							type="text"
							name="marketing_title"
							value={this.state.marketing_title}
							onChange={this.handleChange}
						/>
					</label>
				</div>
				<div>
					<label>
						Description:
						<textarea
							name="marketing_description"
							value={this.state.marketing_description}
							onChange={this.handleChange}
						></textarea>
					</label>
				</div>
				<div>
					<label>
						CTA Text:
						<input
							type="text"
							name="marketing_cta_text"
							value={this.state.marketing_cta_text}
							onChange={this.handleChange}
						/>
					</label>
				</div>
				<div>
					<label>
						CTA URL: (URL must start with https://)
						<input
							placeholder={'https://www.google.com'}
							type="text"
							name="marketing_cta_url"
							value={this.state.marketing_cta_url}
							onChange={this.handleChange}
						/>
					</label>
				</div>
				<div>
					<label>
						Background Color:
						<input
							type="color"
							name="marketing_background_color"
							value={this.state.marketing_background_color}
							onChange={this.handleChange}
						/>
					</label>
				</div>
				<div>
					<label>
						Text Color:
						<input
							type="color"
							name="marketing_foreground_color"
							value={this.state.marketing_foreground_color}
							onChange={this.handleChange}
						/>
					</label>
				</div>

				<div>
					<label>Choose Customer Group:
					<select id="selectRole" value={customer_group} onChange={this.handleSelectChange}>
						<option value="Owner" selected>Account Owners</option>
						<option value="Manager">Manager</option>
						<option value="Supervisor">Supervisor</option>
						<option value="Employee">Employees</option>
						<option value="All">All</option>
					</select>
						<div>
							<span style={{fontWeight: 'bold'}}>Note: banner will display to all customer groups that have access equal to or greater than selected.</span>
						</div>
					</label>
					<p>Selected Role: {customer_group}</p>
				</div>

				<div>
					<div>
						<div>
							<span style={{fontWeight: 'bold'}}>Click Persists to create a banner with the following date ranges.</span>
						</div>
				<FormControl component="fieldset">
					<FormControlLabel control={
						<Checkbox
							checked={this.state.persist}
							onChange={this.handleCheckChangeFor}
							disabled={this.props.disabled}
							style={{
								maxWidth: 250,
								marginBottom: 0,
								marginTop: 0
							}}
						/>
					} label={'Persists'}
					/>
				</FormControl>
					</div>
					<div className="row dateRangeSearch">
						<div className="col-sm">
							<Paper>
							<Framework.Elements.DateTime
								label="Marketing Start date"
								property={this.model.properties.marketing_start_date}
								value={this.state.marketing_start_date}
								update={this.handleDateChange}
								disabled={false}
								/>
							</Paper>
						</div>
					</div>

					<br/> <br/>
					<div className="row dateRangeSearch" >
						<div className="col-sm">
							<Paper>
							<Framework.Elements.DateTime
								label="Marketing End date"
								property={this.model.properties.marketing_end_date}
								value={this.state.marketing_end_date}
								update={this.handleDateChange}
								disabled={false}
							/>
							</Paper>
						</div>
					</div>
				</div>
				<br/>
				<button type="submit">Create Banner</button>
			</form>


				<div> <br/><br/><br/>
					<h3>Current Active Non-Persistent Banner:</h3>
					<div>
						{<Alert className={'brittanys-test-component'} color={this.state?.dismiss_banner?.MarketingBackgroundColor ? '' : 'danger'} style={{backgroundColor: this.state?.dismiss_banner?.MarketingBackgroundColor ?? ''}} data-cy={"disposition-warning"}>
								<p style={{fontSize: '18px', marginBottom: '0px', color: this.state?.dismiss_banner?.MarketingForegroundColor}}>
									<span className={'d-inherit' }><strong>{this.state?.dismiss_banner?.MarketingTitle}</strong> - </span>{this.state?.dismiss_banner?.MarketingDescription}
									{this.state?.dismiss_banner?.MarketingCtaText && <a target={"_blank"} href={this.state?.dismiss_banner?.MarketingCtaUrl}>
										<i >{this.state?.dismiss_banner?.MarketingCtaText}</i>
									</a> }
									{/*<a href={this.state?.dismiss_banner.MarketingCtaUrl} target={'_blank'}>*/}
									<Button color="danger" size="sm" style={{float: 'right'}} onClick={this.handleRemoveBanner}>
										<i className="fa fa-envelope-o"/>Delete Banner From View
									</Button>
								{/*</a>*/}
								</p>
						</Alert>}
						<span>User Access:{this.state?.dismiss_banner?.UserAccess}</span>

					</div>
					<h3>Current Active Persistent Banner:</h3>
					<span>Start Date: {this.state?.persist_banner?.MarketingStartDate}</span> <br/>
					<span>End Date: {this.state?.persist_banner?.MarketingEndDate}</span>
					<div>
						{<Alert className={'brittanys-test-component'} color={this.state?.persist_banner?.MarketingBackgroundColor ? '' : 'danger'} style={{backgroundColor: this.state?.persist_banner?.MarketingBackgroundColor ?? ''}} data-cy={"disposition-warning"}>
							<p style={{fontSize: '18px', marginBottom: '0px', color: this.state?.persist_banner?.MarketingForegroundColor}}>
								<span className={'d-inherit' }><strong>{this.state?.persist_banner?.MarketingTitle}</strong> - </span>{this.state?.persist_banner?.MarketingDescription}
								{this.state?.persist_banner?.MarketingCtaText && <a target={"_blank"} href={this.state?.persist_banner?.MarketingCtaUrl}>
									<i >{this.state?.persist_banner?.MarketingCtaText}</i>
								</a> }
								{/*<a href={this.state?.persist_banner.MarketingCtaUrl} target={'_blank'}>*/}
								<Button color="danger" size="sm" style={{float: 'right'}} onClick={this.handleRemoveBanner}>
									<i className="fa fa-envelope-o"/>Delete Banner From View
								</Button>
								{/*</a>*/}
							</p>
						</Alert>}
						<span>User Access:{this.state?.persist_banner?.UserAccess}</span>

					</div>


				</div>
			</div>
		);
	}
}